import styled from 'styled-components';
import React from 'react';
import media from 'client/styles/media';
import LinkButton from './LinkButton';

const FeatureRequestBlock = styled.div`
  padding-bottom: 20px;
  ${media.sm} {
    display: grid;
    grid-gap: 16px;
    grid-template-columns: repeat(12, 1fr);
  }
  ${media.lg} {
    grid-template-columns: repeat(10, 1fr);
  }
`;
const FeatureRequestText = styled.div`
  margin-bottom: 40px;
  p {
    margin: 5px 0;
  }
  h4 {
    margin: 0 0 5px;
  }
  ${media.sm} {
    grid-column: 1 / span 6;
  }
  ${media.lg} {
    grid-column: 1 / span 5;
  }
`;
const FeatureRequestBtn = styled.div`
  h4 {
    margin: 0 0 20px;
  }
  ${media.sm} {
    grid-column: 8 / span 4;
  }
  ${media.lg} {
    grid-column: 7 / span 3;
  }
`;

const FeatureRequest = () => (
  <FeatureRequestBlock>
    <FeatureRequestText>
      <h4>Feature request</h4>
      <p>
        We develop our product together with the users and customers! What feature you are annoyed to live without? Let
        us know and we will make it a reality!
      </p>
    </FeatureRequestText>

    <FeatureRequestBtn>
      <h4>Let’s become friends</h4>
      <LinkButton variant="pink" to="/contact">
        Drop us a line
      </LinkButton>
    </FeatureRequestBtn>
  </FeatureRequestBlock>
);

export default FeatureRequest;
